module.exports = __webpack_public_path__ + "img/guaranteeIcon4.c6dcd02f.png";